<div class="page-content" [class.loading]="isProcessing">
  <owc-breadcrumb>
    <owc-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs; last as isLast; first as isFirst">
      <span *ngIf="isFirst" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoNotificationPage($event)">
        {{ breadcrumb.label }}
      </span>
      <span *ngIf="!isFirst && !isLast" class="mat-caption" routerLinkActive="router-link-active"
        (click)="gotoNotificationDetailsPage($event)">
        {{ breadcrumb.label }}
      </span>
      <span *ngIf="isLast" class="mat-small">
        {{ breadcrumb.label }}
      </span>
    </owc-breadcrumb-item>
  </owc-breadcrumb>
  
  <ng-container>
  
    <p class="customerTitle">{{ customerTitle }}</p>
  
    <div class="cd-card-row">
  
  
      <owc-card mat-card class="cd-card-list cd-onecard" style="margin-right: 12px;">
  
        <owc-component-header class="cd-mat-card">
          <div style="font-size: 20px;">Account</div>
        </owc-component-header>
  
        <form [formGroup]="accFormGroup">
  
          <div class="cd-item">
  
            <div class="cd-title">Name</div>
  
            <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.AccountName">
              {{ customerData.AccountName }}
            </div>
  
            <div *ngIf="showEditControls">
  
              <owc-input formControlName="formAccName" class="cd-edit-value" />
  
              <owc-assistive-text *ngIf="accFormGroup.controls['formAccName'].invalid" style="margin-top: 5px;">
                    Name must be at least 2 characters.
              </owc-assistive-text>
  
            </div>
  
          </div>
  
          <div class="cd-item" style="margin-top: 10px;">
  
            <div class="cd-title">ID</div>
  
            <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.AccountId">
              {{ customerData.AccountId }}
            </div>
  
            <div *ngIf="showEditControls">
  
              <owc-input formControlName="formAccID" class="cd-edit-value" />
  
              <owc-assistive-text *ngIf="accFormGroup.controls['formAccID'].invalid" style="margin-top: 5px;">
                    ID must be at least 2 characters.
              </owc-assistive-text>
  
            </div>
  
          </div>
  
            <div class="cd-item" style="margin-top: 10px;">
  
              <div class="cd-title">Note</div>
  
              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.NoteText">
                {{  appUtil.formatDateWithTimeUptoSec(customerData.NoteDate) }} <br/>
                {{customerData.NoteText}}
              </div>
  
                <div *ngIf="showEditControls">
  
                <input formControlName="formNote" class="cd-edit-value" />
              </div> 
  
            </div>
  
        </form>
  
  
  
        <div>
  
          <div *ngIf="!userPermission.SendNotification"
            class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton"
            >
            <button (click)="viewAuditTrail()">Audit trail</button>
          </div>
          <owc-modal-dialog [(ngModel)]="visibleAuditTrail">
            <dl-notification-audit-trail [inputData]="inputData"
              (closed)="visibleAuditTrail = false"></dl-notification-audit-trail>
          </owc-modal-dialog>
  
          <div *ngIf="!showEditControls && userPermission.SendNotification"
            class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton"
            >
            <owc-button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</owc-button>
            <owc-button one-secondary-button mat-stroked-button [disabled]="isSetCom || isNotiStat || isSetCancelled ||  customerNotificationData.Status === 'Superseded'"
              (click)="openEditForm()">Edit</owc-button>
          </div>
  
          <div *ngIf="showEditControls && userPermission.SendNotification"
            class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton"
            >
            <owc-button one-secondary-button mat-stroked-button class="cd-close" (click)="closeEditForm()">Cancel</owc-button>
            <owc-button color="primary" mat-flat-button [disabled]="accFormGroup.invalid"
              (click)="editFormDetails()">Save</owc-button>
          </div>
  
        </div>
  
      </owc-card>
  
      <owc-card class="cd-card-list cd-onecard" style="margin-left: 12px;">
        
        <div style="display: flex; align-items: flex-end;">
          <owc-component-header style="margin-bottom: 0px;">
            <div style="font-size: 20px;">Communication</div>
          </owc-component-header>
    
          <div class="cd-chip-status">
            <owc-chip class="customer-details-source-chip truncate-text"  oneChipAppearance="outline" [title]="customerData.AccountStatus"> {{ displayStatus(customerData.AccountStatus) }}</owc-chip>
          </div>
        </div>

        <div class="cd-item">
          <div class="cd-title">Date sent</div>
          <div class="cd-value" [title]="customerData.AccountDateSent">{{
            appUtils.formatDateWithTime(customerData.AccountDateSent) }}</div>
        </div>
  
        <div class="cd-item">
          <div class="cd-title">Date delivered</div>
          <div class="cd-value" [title]="customerData.AccountDateDelivered">{{
            appUtils.formatDateWithTime(customerData.AccountDateDelivered) }}</div>
        </div>
  
        <div class="cd-item">
          <div class="cd-title">Date read</div>
          <div class="cd-value" [title]="customerData.AccountDateRead">{{
            appUtils.formatDateWithTime(customerData.AccountDateRead) }}</div>
        </div>
  
        <div class="cd-item">
          <div class="cd-title">Feedback received</div>
          <div class="cd-value" [title]="customerData.AccountFeedbackReceived">{{
            appUtils.formatDateWithTime(customerData.AccountFeedbackReceived) }}</div>
        </div>
  
        <div class="cd-item">
          <div class="cd-title">Submitter</div>
          <div class="cd-value truncate-text" [title]="customerData.AccountSubmitter">{{ customerData.AccountSubmitter
            }}</div>
        </div>
  
  
  
      </owc-card>
  
    </div>
  
    <div>
      <owc-card class="cd-card-customer" style="padding-right: 15px; padding-bottom: 15px;">
  
        <owc-component-header class="cd-mat-card">
          <div class="cd-feedback-title">Notification</div>
        </owc-component-header>
  
        <owc-component-header class="cd-mat-card" *ngIf="title && title.length > 0">
          <div class="cd-feedback-title">{{ title }}</div>
        </owc-component-header>
  
  
  
        <hr class="horizontal-line" *ngIf="title && title.length > 0">
  
        <div class="cd-feedback-list">
  
          <owc-component-header style="padding: 0px;">
            <div class="cd-feedback-list-title"
              *ngIf="customerNotificationData.MessageTitle && customerNotificationData.MessageTitle.length > 0">
              {{ customerNotificationData.MessageTitle }},
              <span *ngIf="customerData.DateSent" style="margin-left: 5px;">Sent {{
                appUtils.formatDateWithTime(customerData.DateSent) }}</span>
            </div>
          </owc-component-header>
  
          <div class="cd-feedback-list-subject"
            *ngIf="customerNotificationData.MessageBody && customerNotificationData.MessageBody.length > 0">
            <div [innerHTML]="customerNotificationData.MessageBody"></div>
          </div>
  
        </div>
  
        <hr class="horizontal-line">
  
        <div class="cd-feedback-list" style="display: flex; flex-direction: column"
          *ngIf="(customerNotificationData?.NotificationDocuments && customerNotificationData.NotificationDocuments.length > 0 && customerNotificationData.NotificationDocuments[0]?.Title) || (customerNotificationData?.NotificationAttachments && customerNotificationData.NotificationAttachments.length > 0)">
  
          <div class="cd-feedback-list-title">
            Attachments
          </div>
  
          <div class="file-upload-multiple" style="margin-bottom: 0px;">
          <ng-container *ngIf="!isNoAttachmentsVisible()">
            <!-- Global Attachment -->
            <div *ngFor="let attachment of customerNotificationData?.NotificationDocuments">
              <div class="cd-files-list" *ngIf="attachment?.Title && attachment.Title.length > 0 && attachment?.Status!='Removed'">
                <div class="single-file">
                  <div class="info" (click)="downloadDocument(attachment.PIMID, attachment.FileExtension)">
                    <owc-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(attachment?.FileExtension)
                      }}</owc-icon>
                    <span>
                      <span class="name">
                        {{ attachment.Title }}.{{ attachment.FileExtension }}
                        <span class="globalTag">Global</span>
                      </span>
                      <p class="size">{{ formatBytes(attachment?.FileSize) }}</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
  
            <!--Local Attachment-->
            <div *ngFor="let attachmentData of customerNotificationData.NotificationAttachments">
              <div class="cd-files-list" *ngIf="attachmentData.FileName && attachmentData?.Status!='Removed'">
                <div class="single-file">
                  <div class="info" (click)="downloadAttachment(attachmentData.FileName, NotificationId)">
                    <owc-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(attachmentData.FileName)
                      }}</owc-icon>
                    <span>
                      <span class="name">
                        {{ attachmentData.FileName }}
                        <span class="localTag">Local</span>
                      </span>
                      <p class="size">{{ formatBytes(attachmentData.FileSize) }}</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
  
            </ng-container>
  
              <ng-container *ngIf="isNoAttachmentsVisible()">
                <p style="color: red; font-style: italic;margin-left:15px">
                  No attachments added.
                </p>
              </ng-container>
          </div>
  
        </div>
  
        <hr class="horizontal-line"  *ngIf="customerNotificationData.CustomerFeedbackItems && customerNotificationData.CustomerFeedbackItems.length > 0">
  
        <!-- Feedback -->
        <div class="cd-feedback-list"
          *ngIf="customerNotificationData.CustomerFeedbackItems && customerNotificationData.CustomerFeedbackItems.length > 0">
  
          <div class="cd-feedback-list-title">
            Feedback
          </div>
  
          <div *ngFor="let feedbackdatas of customerNotificationData.CustomerFeedbackItems; let i = index" class="feedback-item">
  
            <div class="cd-feedback-list-checkbox" *ngIf="feedbackdatas.FeedbackItemType == 'Checkbox'">
              <section class="example-section">
                 <!-- style="margin-block: 24px;" -->
                <p
                  *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponseCheck">
                  <owc-checkbox disabled
                    [checked]="customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel">
  
                    {{ feedbackdatas.FeedbackItemLabel }}
  
                    <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory"
                      [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                      ({{feedbackdatas.FeedbackItemMandatory}})
                    </span>
  
                  </owc-checkbox>
                </p>
  
                <ng-template #noFeedbakResponseCheck>
                  <p>
                    <owc-checkbox disabled>
  
                      {{ feedbackdatas.FeedbackItemLabel }}
  
                      <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory"
                        [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                        ({{feedbackdatas.FeedbackItemMandatory}})
                      </span>
  
                    </owc-checkbox>
                  </p>
                </ng-template>
  
              </section>
            </div>
  
            <div *ngIf="feedbackdatas.FeedbackItemType == 'Question'">
  
              <div>
  
                <span>{{ feedbackdatas.FeedbackItemLabel }}</span>
  
                <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory"
                  [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                  ({{feedbackdatas.FeedbackItemMandatory}})
                </span>
  
              </div>
  
              <div
                *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponseQuest">
                <owc-input style="padding: 10px 10px 50px 10px !important;" disabled [value]="customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel"
                  class="cd-feedback-list-answer" placeholder="Your answer" />
              </div>
  
              <ng-template #noFeedbakResponseQuest>
                <owc-input style="padding: 10px 10px 50px 10px !important;" disabled [value]="" class="cd-feedback-list-answer" placeholder="Your answer" />
              </ng-template>
  
            </div>
  
            <div *ngIf="feedbackdatas.FeedbackItemType == 'Dropdown'" style="margin-top: 10px;">
  
              <p>
                {{ feedbackdatas.FeedbackItemLabel }}
  
                <span style="font-weight: bold;">(Dropdown)</span>
  
                <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory"
                  [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                  ({{feedbackdatas.FeedbackItemMandatory}})
                </span>
              </p>
  
              <div
                *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponseQuest">
                <p style="font-weight: bold;">
                  {{customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel}}
                </p>
              </div>
  
              <ng-template #noFeedbakResponseQuest>
  
  
                <owc-select-dropdown [limit]="4" [placeholder]="'Type'" [label]="'Select'" rounded>
                  @for (item of feedbackdatas.FeedbackItemDropdown; track item) {
                  <owc-list-item [value]="item">
                    {{item}}
                  </owc-list-item>
                  }
                </owc-select-dropdown>
  
              </ng-template>
  
            </div>
  
            <div *ngIf="feedbackdatas.FeedbackItemType == 'Radio'" style="margin-top: 10px;">
  
              <p>
                {{ feedbackdatas.FeedbackItemLabel }}
  
                <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory"
                  [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                  ({{feedbackdatas.FeedbackItemMandatory}})
                </span>
              </p>
  
              <div
                *ngIf="customerData.AccountFeedbackResponseItems && customerData.AccountFeedbackResponseItems.length > 0; else noFeedbakResponse">
                <owc-radio-group class="radio-group" oneCustomKeyboardHandler aria-labelledby="radio-group-label" [value]="customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel">
                  <owc-radio disabled class="radio-button" [value]="optsRadio"
                   *ngFor="let optsRadio of feedbackdatas.FeedbackItemRadio">
                    {{ optsRadio }}
                  </owc-radio>
                </owc-radio-group>
              </div>
  
              <ng-template #noFeedbakResponse>
                <owc-radio-group class="radio-group" oneCustomKeyboardHandler aria-labelledby="radio-group-label">
                  <owc-radio class="radio-button" [value]="optsRadio"
                    *ngFor="let optsRadio of feedbackdatas.FeedbackItemRadio" disabled>
                    {{ optsRadio }}
                  </owc-radio>
                </owc-radio-group>
              </ng-template>
  
            </div>
  
              <div *ngIf="feedbackdatas.FeedbackItemType == 'Attachment'" style="margin-top: 10px;">
                   <p>
                    {{ feedbackdatas.FeedbackItemLabel }} 
  
                    <span *ngIf="feedbackdatas.FeedbackItemMandatory == 'Optional'" class="chipMandatory" [ngClass]="{ chipOptional: feedbackdatas.FeedbackItemMandatory == 'Optional'}">
                      ({{feedbackdatas.FeedbackItemMandatory}})
                    </span>
                  </p>
                  <div class="cd-files-list">
                    <div class="single-file">
                      <div class="info" *ngIf="customerData.AccountFeedbackResponseItems[i]?.FeedbackResponseItemLabel?.fileName" (click)="downloadAttachment(customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileName, NotificationId, customerData.AccountNotificationId, 'customerFeedbackAttachment')">
                       <owc-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileName) }}</owc-icon>
                        <span>
                          <span class="name">
                            {{ customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileName }}
                          <span class="localTag">Local</span>
                          </span>
                          <p class="size">{{ formatBytes(customerData.AccountFeedbackResponseItems[i].FeedbackResponseItemLabel?.fileSize) }}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
  
        </div>
          <div *ngIf="(accountFeedbackSubmissionDetails.length!=0)&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedFirstName')&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedLastName')&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedEmail')&&
          accountFeedbackSubmissionDetails.hasOwnProperty('CustomerAddedCountry')&&
          accountFeedbackSubmissionDetails.IsNonDialogUser==='TRUE'">
          <!-- && accountFeedbackSubmissionDetails.Type==='SBN' -->
            <hr class="horizontal-line">
  
            <div class="cd-feedback-list">
              
              <div class="cd-feedback-list-title">
                Feedback user details
              </div>
  
              <ul class="feedback-user-details">
                <li><strong>Location:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedCountry}}</li>
                <li><strong>Email:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedEmail}}</li>
                <li><strong>First name:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedFirstName}}</li>
                <li><strong>Middle name (Optional):</strong> {{accountFeedbackSubmissionDetails.CustomerAddedMiddleName}}</li>
                <li><strong>Last name:</strong> {{accountFeedbackSubmissionDetails.CustomerAddedLastName}}</li>
              </ul>
  
            </div>
          </div>
  
  
  
      </owc-card>
    </div>
  
    <!-- Recipients Table -->
    <dl-contact-table style="margin-top: 25px;"></dl-contact-table>
  
  </ng-container>
</div>
